import React from 'react';

const OpenInferLogo = ({ 
  className = "w-12 h-12", 
  color = "black",
  size = 48,
  ...props 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      fill="none" 
      viewBox="0 0 500 500"
      className={className}
      width={size}
      height={size}
      style={{ fill: color }}
      {...props}
    >
      <path 
        fill="currentColor" 
        d="M393.181 406.703c-2.004 1.832-3.181 4.407-3.181 7.121v25.548c0 7.566 8.41 11.972 14.359 7.297C462.595 400.898 500 329.817 500 250 500 111.929 388.071 0 250 0S0 111.929 0 250c0 79.817 37.405 150.898 95.641 196.669 5.949 4.675 14.359.269 14.359-7.297v-25.548c0-2.715-1.177-5.289-3.181-7.121C64.365 367.891 37.736 312.055 37.736 250 37.736 132.77 132.77 37.736 250 37.736S462.264 132.77 462.264 250c0 62.055-26.629 117.891-69.083 156.703Z"
      />
      <path 
        fill="currentColor" 
        d="M185.283 202.5a4.717 4.717 0 0 1 4.717 4.717v277.061c0 4.553-4.238 7.923-8.635 6.747a262.743 262.743 0 0 1-26.945-8.786c-2.682-1.037-4.42-3.636-4.42-6.512v-268.51a4.717 4.717 0 0 1 4.717-4.717h30.566ZM350 207.217a4.717 4.717 0 0 0-4.717-4.717h-30.566a4.717 4.717 0 0 0-4.717 4.717v277.061c0 4.553 4.238 7.923 8.636 6.747a262.725 262.725 0 0 0 26.944-8.786c2.683-1.037 4.42-3.636 4.42-6.512v-268.51ZM265.283 307.5a4.717 4.717 0 0 1 4.717 4.717v183.066a4.717 4.717 0 0 1-4.717 4.717h-30.566a4.717 4.717 0 0 1-4.717-4.717V312.217a4.717 4.717 0 0 1 4.717-4.717h30.566ZM282.5 235c0 17.949-14.551 32.5-32.5 32.5-17.949 0-32.5-14.551-32.5-32.5 0-17.949 14.551-32.5 32.5-32.5 17.949 0 32.5 14.551 32.5 32.5Z"
      />
    </svg>
  );
};

export default OpenInferLogo;
